import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@utils/cn';
const paddingStyles = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
};
export function Card({ children, hoverable = false, padding = 'md', className, ...props }) {
    return (_jsx("div", { className: cn('card rounded-lg bg-dark-600 border border-gray-800 shadow-card', hoverable && 'cursor-pointer transition-shadow duration-200 hover:shadow-card-hover', paddingStyles[padding], className), ...props, children: children }));
}
// Card 子组件
export function CardHeader({ children, className, ...props }) {
    return (_jsx("div", { className: cn('mb-4', className), ...props, children: children }));
}
export function CardTitle({ children, className, ...props }) {
    return (_jsx("h3", { className: cn('text-lg font-semibold text-gray-100', className), ...props, children: children }));
}
export function CardContent({ children, className, ...props }) {
    return (_jsx("div", { className: cn('text-gray-400', className), ...props, children: children }));
}
export function CardFooter({ children, className, ...props }) {
    return (_jsx("div", { className: cn('mt-4 flex items-center gap-2', className), ...props, children: children }));
}
